// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* LAKPED-16.7 — panel de seguimiento. Mismos valores que el prototipo de Paula (pantalla \`panel\`)
   y acotado a .panel, que el CSS de CRA es global. */

.panel {
  max-width: 1200px;
  margin: 0 auto;
  padding: 28px 32px 60px;
}

.panel-error { color: #b71c1c; font-size: 14px; }

.panel-cabecera {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 20px;
}

.panel h1 { font-size: 26px; font-weight: 600; margin: 0 0 4px; color: #1b1b1b; }
.panel-sub { color: #666; font-size: 14px; margin: 0; max-width: 620px; }

.panel-filtros { display: flex; gap: 8px; }

.panel .panel-filtros select {
  font: inherit;
  font-size: 14px;
  padding: 7px 10px;
  border: 1px solid #ccc;
  border-radius: 6px;
  background: #fff;
}

/* Indicadores */
.panel-kpis {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 14px;
  margin-bottom: 16px;
}

.panel-kpi {
  background: #fff;
  border: 1px solid #e3e3e3;
  border-radius: 10px;
  padding: 16px 18px;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.panel-kpi small { font-size: 12px; color: #777; }
.panel-kpi b { font-size: 24px; font-weight: 600; color: #1b1b1b; }
.panel-kpi em { font-style: normal; font-size: 12px; color: #999; }

/* Dos columnas */
.panel-columnas {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  align-items: start;
}

.panel-tarjeta {
  background: #fff;
  border: 1px solid #e3e3e3;
  border-radius: 10px;
  padding: 18px 20px;
}

.panel-tarjeta h2 { font-size: 15px; font-weight: 600; margin: 0 0 14px; color: #1b1b1b; }
.panel-vacio { font-size: 13px; color: #888; margin: 0; }

.panel-tabla { width: 100%; border-collapse: collapse; font-size: 14px; }
.panel-tabla th {
  text-align: left;
  font-size: 12px;
  font-weight: 600;
  color: #666;
  padding: 6px 8px;
  border-bottom: 1px solid #eee;
}
.panel-tabla td { padding: 8px; border-bottom: 1px solid #f4f4f4; color: #222; }
.panel-tabla th.der, .panel-tabla td.der { text-align: right; }
.panel-tabla tr.pinchable { cursor: pointer; }
.panel-tabla tr.pinchable:hover td { background: #fafafa; }

.panel-barra { background: #eee; border-radius: 5px; height: 10px; overflow: hidden; min-width: 90px; }
.panel-barra i { display: block; height: 100%; background: #1a9b5a; }

/* Horas por mes */
.panel-barras {
  display: flex;
  align-items: flex-end;
  gap: 10px;
  height: 170px;
  border-bottom: 1px solid #ddd;
  padding: 0 4px;
}

.panel-mes { flex: 1 1; display: flex; flex-direction: column; align-items: center; height: 100%; }

.panel-mes-barras {
  flex: 1 1;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  gap: 3px;
  width: 100%;
}

.panel-mes-barras i { display: block; width: 9px; background: #111; border-radius: 3px 3px 0 0; min-height: 1px; }
.panel-mes-barras i.anterior { background: #d8d8d8; }
.panel-mes-barras i.facturar { background: #7c9ee8; }
.panel-mes span { font-size: 11px; color: #888; margin-top: 6px; }

.panel-leyenda { font-size: 12px; color: #666; margin: 10px 0 0; }
.panel-leyenda span {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 2px;
  margin: 0 4px 0 12px;
  background: #111;
}
.panel-leyenda span.facturar { background: #7c9ee8; }
.panel-leyenda span.anterior { background: #d8d8d8; }

.panel-ancho { margin-top: 16px; }

.panel-nota { font-size: 12.5px; color: #888; margin: 12px 0 0; }

@media (max-width: 900px) {
  .panel { padding: 20px 16px 40px; }
  .panel-columnas { grid-template-columns: 1fr; }
  .panel-tarjeta { overflow-x: auto; }
}
`, "",{"version":3,"sources":["webpack://./src/pages/DashboardPage.css"],"names":[],"mappings":"AAAA;qDACqD;;AAErD;EACE,iBAAiB;EACjB,cAAc;EACd,uBAAuB;AACzB;;AAEA,eAAe,cAAc,EAAE,eAAe,EAAE;;AAEhD;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA,YAAY,eAAe,EAAE,gBAAgB,EAAE,eAAe,EAAE,cAAc,EAAE;AAChF,aAAa,WAAW,EAAE,eAAe,EAAE,SAAS,EAAE,gBAAgB,EAAE;;AAExE,iBAAiB,aAAa,EAAE,QAAQ,EAAE;;AAE1C;EACE,aAAa;EACb,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA,mBAAmB,eAAe,EAAE,WAAW,EAAE;AACjD,eAAe,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE;AAClE,gBAAgB,kBAAkB,EAAE,eAAe,EAAE,WAAW,EAAE;;AAElE,iBAAiB;AACjB;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,oBAAoB,eAAe,EAAE,gBAAgB,EAAE,gBAAgB,EAAE,cAAc,EAAE;AACzF,eAAe,eAAe,EAAE,WAAW,EAAE,SAAS,EAAE;;AAExD,eAAe,WAAW,EAAE,yBAAyB,EAAE,eAAe,EAAE;AACxE;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,6BAA6B;AAC/B;AACA,kBAAkB,YAAY,EAAE,gCAAgC,EAAE,WAAW,EAAE;AAC/E,2CAA2C,iBAAiB,EAAE;AAC9D,4BAA4B,eAAe,EAAE;AAC7C,qCAAqC,mBAAmB,EAAE;;AAE1D,eAAe,gBAAgB,EAAE,kBAAkB,EAAE,YAAY,EAAE,gBAAgB,EAAE,eAAe,EAAE;AACtG,iBAAiB,cAAc,EAAE,YAAY,EAAE,mBAAmB,EAAE;;AAEpE,kBAAkB;AAClB;EACE,aAAa;EACb,qBAAqB;EACrB,SAAS;EACT,aAAa;EACb,6BAA6B;EAC7B,cAAc;AAChB;;AAEA,aAAa,SAAO,EAAE,aAAa,EAAE,sBAAsB,EAAE,mBAAmB,EAAE,YAAY,EAAE;;AAEhG;EACE,SAAO;EACP,aAAa;EACb,qBAAqB;EACrB,uBAAuB;EACvB,QAAQ;EACR,WAAW;AACb;;AAEA,sBAAsB,cAAc,EAAE,UAAU,EAAE,gBAAgB,EAAE,0BAA0B,EAAE,eAAe,EAAE;AACjH,+BAA+B,mBAAmB,EAAE;AACpD,+BAA+B,mBAAmB,EAAE;AACpD,kBAAkB,eAAe,EAAE,WAAW,EAAE,eAAe,EAAE;;AAEjE,iBAAiB,eAAe,EAAE,WAAW,EAAE,gBAAgB,EAAE;AACjE;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;AAClB;AACA,+BAA+B,mBAAmB,EAAE;AACpD,+BAA+B,mBAAmB,EAAE;;AAEpD,eAAe,gBAAgB,EAAE;;AAEjC,cAAc,iBAAiB,EAAE,WAAW,EAAE,gBAAgB,EAAE;;AAEhE;EACE,SAAS,uBAAuB,EAAE;EAClC,kBAAkB,0BAA0B,EAAE;EAC9C,iBAAiB,gBAAgB,EAAE;AACrC","sourcesContent":["/* LAKPED-16.7 — panel de seguimiento. Mismos valores que el prototipo de Paula (pantalla `panel`)\n   y acotado a .panel, que el CSS de CRA es global. */\n\n.panel {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 28px 32px 60px;\n}\n\n.panel-error { color: #b71c1c; font-size: 14px; }\n\n.panel-cabecera {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 16px;\n  margin-bottom: 20px;\n}\n\n.panel h1 { font-size: 26px; font-weight: 600; margin: 0 0 4px; color: #1b1b1b; }\n.panel-sub { color: #666; font-size: 14px; margin: 0; max-width: 620px; }\n\n.panel-filtros { display: flex; gap: 8px; }\n\n.panel .panel-filtros select {\n  font: inherit;\n  font-size: 14px;\n  padding: 7px 10px;\n  border: 1px solid #ccc;\n  border-radius: 6px;\n  background: #fff;\n}\n\n/* Indicadores */\n.panel-kpis {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 14px;\n  margin-bottom: 16px;\n}\n\n.panel-kpi {\n  background: #fff;\n  border: 1px solid #e3e3e3;\n  border-radius: 10px;\n  padding: 16px 18px;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.panel-kpi small { font-size: 12px; color: #777; }\n.panel-kpi b { font-size: 24px; font-weight: 600; color: #1b1b1b; }\n.panel-kpi em { font-style: normal; font-size: 12px; color: #999; }\n\n/* Dos columnas */\n.panel-columnas {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 16px;\n  align-items: start;\n}\n\n.panel-tarjeta {\n  background: #fff;\n  border: 1px solid #e3e3e3;\n  border-radius: 10px;\n  padding: 18px 20px;\n}\n\n.panel-tarjeta h2 { font-size: 15px; font-weight: 600; margin: 0 0 14px; color: #1b1b1b; }\n.panel-vacio { font-size: 13px; color: #888; margin: 0; }\n\n.panel-tabla { width: 100%; border-collapse: collapse; font-size: 14px; }\n.panel-tabla th {\n  text-align: left;\n  font-size: 12px;\n  font-weight: 600;\n  color: #666;\n  padding: 6px 8px;\n  border-bottom: 1px solid #eee;\n}\n.panel-tabla td { padding: 8px; border-bottom: 1px solid #f4f4f4; color: #222; }\n.panel-tabla th.der, .panel-tabla td.der { text-align: right; }\n.panel-tabla tr.pinchable { cursor: pointer; }\n.panel-tabla tr.pinchable:hover td { background: #fafafa; }\n\n.panel-barra { background: #eee; border-radius: 5px; height: 10px; overflow: hidden; min-width: 90px; }\n.panel-barra i { display: block; height: 100%; background: #1a9b5a; }\n\n/* Horas por mes */\n.panel-barras {\n  display: flex;\n  align-items: flex-end;\n  gap: 10px;\n  height: 170px;\n  border-bottom: 1px solid #ddd;\n  padding: 0 4px;\n}\n\n.panel-mes { flex: 1; display: flex; flex-direction: column; align-items: center; height: 100%; }\n\n.panel-mes-barras {\n  flex: 1;\n  display: flex;\n  align-items: flex-end;\n  justify-content: center;\n  gap: 3px;\n  width: 100%;\n}\n\n.panel-mes-barras i { display: block; width: 9px; background: #111; border-radius: 3px 3px 0 0; min-height: 1px; }\n.panel-mes-barras i.anterior { background: #d8d8d8; }\n.panel-mes-barras i.facturar { background: #7c9ee8; }\n.panel-mes span { font-size: 11px; color: #888; margin-top: 6px; }\n\n.panel-leyenda { font-size: 12px; color: #666; margin: 10px 0 0; }\n.panel-leyenda span {\n  display: inline-block;\n  width: 10px;\n  height: 10px;\n  border-radius: 2px;\n  margin: 0 4px 0 12px;\n  background: #111;\n}\n.panel-leyenda span.facturar { background: #7c9ee8; }\n.panel-leyenda span.anterior { background: #d8d8d8; }\n\n.panel-ancho { margin-top: 16px; }\n\n.panel-nota { font-size: 12.5px; color: #888; margin: 12px 0 0; }\n\n@media (max-width: 900px) {\n  .panel { padding: 20px 16px 40px; }\n  .panel-columnas { grid-template-columns: 1fr; }\n  .panel-tarjeta { overflow-x: auto; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
